var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '..';
import styles from './ProgressBar.module.css';
var ProgressBar = function (_a) {
    var progress = _a.progress, className = _a.className;
    return (_jsxs("div", __assign({ className: [styles.progressContainer, className].join(' ') }, { children: [_jsx("div", __assign({ className: [styles.progress, styles.progressBack].join(' ') }, { children: _jsx("div", { className: [styles.progress, styles.progressFront].join(' '), style: { width: "".concat(progress * 100, "%") } }, void 0) }), void 0), _jsx(Typography, __assign({ variant: "medium", className: styles.percent }, { children: "".concat((progress * 100).toFixed(2), "%") }), void 0)] }), void 0));
};
export default ProgressBar;
